//
//
//
//
//
//

export default {
	name: 'commentItem',
	components: {},
	props: {
		info: {
			type: Object,
			default () {
				return {
				collectionType: '', // 收藏类型(10:咨询 20:产品 30:主体 40:导游)(非必填)
				productGroupType: '', // 产品组别(1001:门票产品 1002:房型产品 1003:美食产品 1004:特产产品 1005:旅游线路 2001:景区主体 2002:酒店主体 2003:餐馆主体)(非必填)
				collectionId: '', // 收藏参数(例如供应商产品id)(必填)
				}
			}
		}
	},
	data() {
		return {
			status: 0,
			id: '',
			isAble: false
		}
	},
	computed: {
		collectImg() {
			return this.status === 1 ? require('@/static/public/collect.png') : require('@/static/public/unCollect.png')
		}
	},
	mounted() {
		this.queryData()
	},
	methods: {
		queryData() {
			this.$nextTick(() => {
				if (this.$store.state.userInfo.memberId) {
					this.$ajax({
						method: 'post',
						url: '/weChat/mycollection/selectStatus',
						data: {
							userId: this.$store.state.userInfo.memberId,
							id: this.info.collectionId
						}
					}).then(result => {
						this.status = result.data.status
						this.id = result.data.id
					})
				}
			})
		},
		addCollect() {
			if (this.status === 0) {
				this.$ajax({
					method: 'post',
					url: '/weChat/mycollection/add',
					data: {
						userId: this.$store.state.userInfo.memberId,
						appId: this.$store.state.storeConfig.wxAppid,
						...this.info
					}
				}).then(res => {
					if(res.errCode===8200){
						uni.showToast({
							title: '收藏成功',
							icon: 'none'
						})
					}
					this.queryData()
				})
			} else if (this.status === 1) {
				this.$ajax({
					method: 'post',
					url: '/weChat/mycollection/delete',
					data: {
						id: this.id
					}
				}).then(res => {
					if(res.errCode===8200){
						uni.showToast({
							title: '已取消',
							icon: 'none'
						})
					}
					this.queryData()
				})
			}
		}
	}
}
